import axios from "axios";

const api = axios.create({
	baseURL: window.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export default api;
